import type { ShiftRQSchema } from '@libs/data-access/queries'
import { useForm } from 'react-hook-form'

type UnvalidateForm = {
  shift: ShiftRQSchema
}

export const useUnvalidateShiftForm = ({ shift }: UnvalidateForm) => {
  const methods = useForm<ShiftRQSchema>({
    mode: 'onBlur',
    defaultValues: {
      ...shift,
      validated_at: null
    }
  })

  return {
    methods
  }
}
